import React from "react";
import { Range, getTrackBackground } from "react-range";
import styled, { withTheme } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 0.5em;

  & .mini-track {
      div {
          font-size: 10px !important;
      }
  }
`;

const MiniRangeSlider = ({
  values = [],
  currentValue,
  step = 1,
  min = 0,
  max = 100,
  markStep = 10,
  thumbColors = ["#707070", "#707070"],
  trackColors = ["#AAA", "#AAA", "#AAA"],
  disabled = true,
  labels = [],
  currentValueText,
  thumbValFnc,
  ...rest
}) => {
  return (
    <Container>
      <Range
        values={values}
        step={step}
        min={min}
        max={max}
        disabled={disabled}
        renderMark={({ props, index }) => (
          <>
            {currentValue !== null && currentValue !== undefined &&
            (currentValue === index * step ||
              currentValue === index ||
              (currentValue % step !== 0 &&
                currentValue > index * step &&
                currentValue < (index + 1) * step)) ? (
              <div
                {...props}
                style={{
                  ...props.style,
                  width: 4,
                  borderTop: `24px solid #AAAAAA`,
                  marginTop: "4px",
                  display: "block",
                }}
              >
                {/* <DownArrow /> */}
                <div
                  style={{
                    marginLeft: "-3px",
                    display: "inline-block",
                    width: 150,
                  }}
                >
                  {currentValue}
                </div>
              </div>
            ) : null}
          </>
        )}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "36px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values: values,
                  colors: trackColors, //["red", "orange", "green", "red"],
                  min: min,
                  max: max,
                }),
                alignSelf: "center",
              }}
              className="mini-track"
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, value, index, isDragged }) => (
          <>
            <div
              {...props}
              style={{
                ...props.style,
                height: "30px",
                width: "30px",
                borderRadius: "50%",
                backgroundColor: '#707070', //index === 0 ? "red" : index === 1 ? "orange" : "green",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //boxShadow: "0px 2px 6px #AAA",
                fontSize: "13px",
                color: "white",
                outline: "none",
                boxShadow: "none",
              }}
            >
              {thumbValFnc ? thumbValFnc(value) : value}
              {isDragged && (
                <div
                  style={{
                    ...props.style,
                    transform: "translateY(-22px)",
                    color: "#d4cfcf",
                  }}
                >
                  {value}
                </div>
              )}
            </div>
          </>
        )}
      />
    </Container>
  );
};

export default withTheme(MiniRangeSlider);
